import Joi from "joi-browser";
import { useThirdPartySettings } from "../Acuity/useThirdPartySettings";
import { useMemo, useState } from "react";
import { message } from "antd";
import * as thirdpartyService from "V2.0/services/thirdpartyService";
import { showErrorToast } from "V2.0/utils";
import Form from "V2.0/components/Form";

const template = [
  {
    name: "apiKey",
    label: "API key *",
    type: "text",
  },
  {
    name: "eventTypeId",
    label: "Event Type Id *",
    type: "text",
  },
  {
    name: "SECTION",
    label: "Backup Details",
  },
  {
    name: "firstName",
    label: "First Name",
    type: "text",
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
  },
  {
    name: "countryCode",
    label: 'Country Code (Prefix with "+")',
    type: "text",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
  },
];

const schema = {
  apiKey: Joi.string().required().label("API Key"),
  eventTypeId: Joi.string().required().label("Event Type Id"),
  firstName: Joi.string().allow(null, "").label("First Name"),
  lastName: Joi.string().allow(null, "").label("Last Name"),
  email: Joi.string().email().allow(null, "").label("Email"),
  countryCode: Joi.string().allow(null, "").label("Country Code"),
};

export default function CalForm(props) {
  const { workspaceId, isViewOnly } = props;
  const [loading, setLoading] = useState(false);
  const { thirdPartySettings, fetchThirdPartySettings } =
    useThirdPartySettings(workspaceId);

  const calSettings = useMemo(() => {
    const {
      apiKey,
      eventTypeId,
      backupDetails: { firstName, lastName, email, countryCode },
    } = thirdPartySettings?.calendarSettings?.calDotComSettings || {
      apiKey: "",
      eventTypeId: "",
      backupDetails: {
        firstName: "",
        lastName: "",
        email: "",
        countryCode: "",
      },
    };

    return {
      apiKey,
      eventTypeId,
      firstName,
      lastName,
      email,
      countryCode,
    };
  }, [thirdPartySettings]);

  const updatedTemplate = useMemo(() => {
    if (!isViewOnly) {
      return template;
    }

    return template.map((field) => {
      return {
        ...field,
        disabled: isViewOnly,
      };
    });
  }, [isViewOnly]);

  const updatedButtonInfo = !isViewOnly
    ? {
        label: "Save Calendar settings",
        style: "entire-width",
      }
    : {};

  const handleSave = async (data) => {
    const { firstName, lastName, email, countryCode, ...rest } = data;
    const payload = {
      ...rest,
      backupDetails: {
        firstName,
        lastName,
        email,
        countryCode,
      },
    };
    message.loading("Saving Cal settings");

    try {
      const response = await thirdpartyService.thirdpartyUpdate(
        {
          calendarSettings: {
            calendarProvider: "CalDotCom",
            calDotComSettings: payload,
          },
        },
        workspaceId,
      );

      if (response.status === 200) {
        fetchThirdPartySettings();
        message.destroy();
        message.success("Settings saved");
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to save settings");
    }
  };

  return (
    <div className="border rounded-lg flex flex-col mx-auto px-8 py-8">
      <div className="flex gap-x-2 mb-4">
        <img
          src="https://cal.com/logo.svg"
          width={60}
        />
        {/* <h3 className="text-base font-semibold leading-6 text-gray-900">
          Cal.Com
        </h3> */}
      </div>
      <div>
        <Form
          formTitle=""
          template={updatedTemplate}
          inputField={calSettings}
          schema={schema}
          loading={loading}
          setLoading={setLoading}
          onSubmit={handleSave}
          buttonInfo={updatedButtonInfo}
        />
      </div>
    </div>
  );
}
